import { Box, CircularProgress, TextField, useTheme } from "@material-ui/core";
import { Button } from "components";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import storageService from "services/storageService";
import { Dialog } from "shared";
import * as Yup from "yup";

import { Text } from "../style";

export const BatchBlockPopup = ({ open, data, handleClose, refresh }) => {
  const theme = useTheme();
  const { addPopup } = usePopup();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    productQuantity: "",
    observation: ""
  };

  const validationSchema = Yup.object().shape({
    productQuantity: Yup.number()
      .positive()
      .typeError("Deve ser um número")
      .required("Campo obrigatório")
      .test(
        "integerValidation",
        "Deve ser um número inteiro",
        function (value) {
          return !(data.purchaseType === "Un" && !Number.isInteger(value));
        }
      ),
    observation: Yup.string()
      .min(5, "Mínimo de 5 caracteres")
      .required("Campo obrigatório")
  });

  const onConfirm = async values => {
    setLoading(true);
    try {
      await storageService.lockStorage({
        quantity: values.productQuantity,
        storage_id: data?.storageId,
        observation: values.observation
      });
      addPopup({
        type: "success",
        title: "Quantidade bloqueada atualizada com sucesso!"
      });
      handleClose();
      refresh();
    } catch {
      addPopup({
        type: "error",
        title: "Houve um erro ao bloquear o Lote"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title="Bloquear Lote"
      maxWidth="32rem"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onConfirm}
      >
        <Form>
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              margin="2rem 0"
            >
              <CircularProgress color="primary" />
            </Box>
          ) : (
            <>
              <Text>Qual a quantidade que será bloqueada?</Text>

              <Field
                as={TextField}
                fullWidth
                name="productQuantity"
                placeholder={data.purchaseType}
                type="number"
                variant="outlined"
              />
              <ErrorMessage
                name="productQuantity"
                component="div"
                style={{ color: "red" }}
              />

              <Text>Qual o motivo do bloqueio?</Text>

              <Field
                as={TextField}
                fullWidth
                name="observation"
                placeholder="Motivo"
                variant="outlined"
              />
              <ErrorMessage
                name="observation"
                component="div"
                style={{ color: "red" }}
              />

              <Box
                display="flex"
                marginTop="1rem"
                style={{ gap: "1rem", marginTop: "80px" }}
              >
                <Button onClick={handleClose} variant="text" fullWidth>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="warning"
                  isLoading={loading}
                  fullWidth
                >
                  Bloquear
                </Button>
              </Box>
            </>
          )}
        </Form>
      </Formik>
    </Dialog>
  );
};
